import * as React from 'react';

import {Button} from 'shells/button/button';
import {colors} from 'shells/colors/colors';
import {Body} from 'shells/typography/body';

import {appHistory} from '../../history';

export function NoIntegrationsEmptyState() {
    return (
        <div className='flex flex-dir-col pad-32 border-box full-height'>
            <div
                style={{background: colors.blueBg}}
                className='pad-64 flex flex-dir-col border-box full-width full-height justify-center align-center'
            >
                <div className='mb-8'>
                    <Body isBold={true} color='dark' useDoyle={true} size='xlarge'>
                        Start syncing your calls to Nutshell
                    </Body>
                </div>
                <div className='mb-32 text-align-center' style={{maxWidth: 650}}>
                    <Body size='large'>
                        Connect with your phone systems to streamline your workflow. Check out your
                        call logs here before logging them into your contacts timeline.{' '}
                    </Body>
                </div>
                <div className='mb-32'>
                    <img
                        src='/include/images/external-meetings/calls-empty-state-large.png'
                        alt='Calls empty state'
                        style={{width: '100%', maxWidth: 1200}}
                    />
                </div>
                <Button
                    variant='primary'
                    size='xlarge'
                    onClick={() => {
                        appHistory.push({
                            pathname: window.location.pathname,
                            search: window.location.search,
                            hash: '#/connect-phone-integration/get-started',
                        });
                    }}
                >
                    Get started now
                </Button>
            </div>
        </div>
    );
}
